
export default {
    props: {
        /**
         * A File object
         */
        file: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            preview: '',
        };
    },
    computed: {
        fileTooLarge() {
            return this.file.data.size > this.$config.maxFileSize;
        },
        progressStyle() {
            return `width: ${this.file.progress}%`;
        },
    },
    created() {
        this.getPreview();
        if (this.fileTooLarge) {
            /* eslint vue/no-mutating-props: 0 */
            // @todo fix this
            this.file.hasError = true;
        }
    },
    methods: {
        getPreview() {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.preview = e.target.result;
            };
            reader.readAsDataURL(this.file.data);
        },
    },
};

